import React, { useEffect } from 'react';

export default function ImageProtection() {
  useEffect(() => {
    // Block right-click everywhere
    const handleContextMenu = (e) => e.preventDefault();

    // Block drag on images and selected text
    const handleDragStart = (e) => e.preventDefault();

    // Block copy, cut, select-all, save, print, view-source, devtools
    const handleKeyDown = (e) => {
      const ctrl = e.ctrlKey || e.metaKey;
      if (ctrl && ['c', 'x', 'a', 's', 'u', 'p'].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
      if (e.key === 'F12' || (ctrl && e.shiftKey && ['i', 'j', 'c'].includes(e.key.toLowerCase()))) {
        e.preventDefault();
      }
      if (e.key === 'PrintScreen') {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('keydown', handleKeyDown);

    // Inject protection CSS
    if (!document.querySelector('style[data-content-protection]')) {
      const style = document.createElement('style');
      style.setAttribute('data-content-protection', 'true');
      style.textContent = `
        * {
          user-select: none !important;
          -webkit-user-select: none !important;
          -moz-user-select: none !important;
          -ms-user-select: none !important;
        }
        input, textarea, [contenteditable] {
          user-select: text !important;
          -webkit-user-select: text !important;
        }
        img {
          -webkit-user-drag: none !important;
          user-drag: none !important;
          pointer-events: none !important;
        }
        a img, button img {
          pointer-events: auto !important;
        }
      `;
      document.head.appendChild(style);
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return null;
}